import http from "./http";

export default (tripId) => ({
  async index(filters) {
    return http
      .index("delivery-trips", filters)
      .then((json) => ({ trips: json }))
      .catch(async (e) => ({ trips: null, error: await e }));
  },
  async get() {
    return http
      .get("delivery-trips", tripId)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async create(data) {
    return http
      .post("delivery-trips", data)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async update(data) {
    return http
      .put("delivery-trips", tripId, data)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async delete() {
    return http
      .delete("delivery-trips", tripId)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async depart(data = {}) {
    return http
      .put("delivery-trips", `${tripId}/depart`, data)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async arrive(data = {}) {
    return http
      .put("delivery-trips", `${tripId}/arrive`, data)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
  async finish(data = {}) {
    return http
      .put("delivery-trips", `${tripId}/finish`, data)
      .then((json) => ({ trip: json }))
      .catch(async (e) => ({ trip: null, error: await e }));
  },
});
